import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ClientModelRestEndpointsPlusUpdatesWebsocketClass;
function ClientModelRestEndpointsPlusUpdatesWebsocket() {
  if (ClientModelRestEndpointsPlusUpdatesWebsocketClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ClientModelRestEndpointsPlusUpdatesWebsocket');
    ClientModelRestEndpointsPlusUpdatesWebsocketClass = $;
  }
  return ClientModelRestEndpointsPlusUpdatesWebsocketClass;
}
var LimitReadableClass;
function LimitReadable() {
  if (LimitReadableClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'LimitReadable', VOID, VOID, [Reactive()]);
    LimitReadableClass = $;
  }
  return LimitReadableClass;
}
//region block: exports
export {
  ClientModelRestEndpointsPlusUpdatesWebsocket as ClientModelRestEndpointsPlusUpdatesWebsocket34r6fusayskwn,
  LimitReadable as LimitReadable2ecfn2s8p9gvk,
};
//endregion

//# sourceMappingURL=deprecated.mjs.map
